import { Add, FileUpload, ExpandMore, ChevronRight, } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import { gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg6, texto } from "@/shared";
import DownloadIcon from '@mui/icons-material/Download';
import { TreeView } from '@mui/x-tree-view/TreeView';

import RenderTreeComponente from "./componente/RenderTreeComponente";
import { useState } from "react";

import { CustomTextField, LoaderComponent } from "@/shared/components/ui";
import { usePlanCuenta } from "@/shared/hooks/usePlanCuenta";
import { useAuthStore } from "@/store/auth";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";

export interface IPlanCuentaFrom {
  nombre: string;
  codigo: string;
  tipo_cuenta_contable?: string;
  node_id?: string;
}

export default function PlanCuentaPage() {

  const [btnExpanded, setBtnExpanded] = useState(true);

  const {
    fileInputRef,

    treeData,
    addNode,
    deleteNode,
    editNode,
    setEditNodeId,
    editNodeId,
    editNodeName,
    setEditNodeName,

    expanded,
    handleToggle,
    handleCollapseAll,
    handleExpandAll,
    handleFileUpload,
    handleDownloadPlantilla,
    isLoadingPlanCuenta,
    isPendingEditarPlanCuenta,

    setModalOpen,
    modalOpen,

    onSubmit,
    form,
    handleSubmit
  } = usePlanCuenta()


  const empresa = useAuthStore(s => s.user?.empresa);

  if (isPendingEditarPlanCuenta || isLoadingPlanCuenta) return <LoaderComponent />


  return (
    <>
      <Grid container spacing={2} justifyContent={'space-between'}>
        <Grid item xs={12}>
          {/* <Typography variant="h4">{`Plan de cuenta ${empresa}`}</Typography> */}

          <Typography variant="h4">
            {`Plan de cuenta `}
            <span className="cliente__page--subtitle">
              ({empresa})
            </span>
          </Typography>
        </Grid>

        <Grid item {...gridSizeMdLg6}>
          <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileUpload}
            style={{ display: 'none' }}
            accept=".xls, .xlsx"
            id="btn-upload-file-plan-cuenta"
          />

          <label htmlFor="btn-upload-file-plan-cuenta">
            <Button

              component="span"
              variant="text"
              color="inherit"
              startIcon={<FileUpload />}
            >
              Importar Plan de Cuenta (EXCEL)
            </Button>
          </label>
        </Grid>

        <Grid item container {...gridSizeMdLg6} spacing={1}>
          <Grid item {...gridSizeMdLg4}>
            <Button
              style={{
                color: 'white',
                background: 'black'
              }}
              fullWidth
              variant="contained"
              startIcon={<Add />}
              onClick={() => {
                addNode('');
              }}
            >
              Cuenta
            </Button>
          </Grid>

          <Grid item {...gridSizeMdLg4} >
            <Button
              style={{
                color: 'white',
                background: 'black'
              }}
              fullWidth
              variant="outlined"
              color="inherit"
              startIcon={btnExpanded ? <UnfoldMoreIcon /> : <UnfoldLessIcon />}
              onClick={() => {
                btnExpanded ?
                  handleExpandAll()
                  : handleCollapseAll()
                setBtnExpanded(!btnExpanded)
              }
              }
            >
              {btnExpanded ? 'Expandir' : 'Ocultar'}
            </Button>
          </Grid>

          <Grid item {...gridSizeMdLg4}>
            <Button
              onClick={handleDownloadPlantilla}
              style={{
                color: 'white',
                background: 'black'
              }}
              fullWidth
              variant="outlined"
              color="inherit"
              startIcon={<DownloadIcon />
              }
            >
              Plantilla
            </Button>
          </Grid>
        </Grid>


        {
          treeData.length === 0 && (
            <Grid item xs={12}>
              <Typography variant="body1">{`No hay plan de cuenta cargado`}</Typography>
            </Grid>
          )
        }

        {treeData.length !== 0 && (
          <Grid item {...gridSizeMdLg12}>
            <TreeView
              defaultCollapseIcon={<ExpandMore />}
              defaultExpandIcon={<ChevronRight />}
              sx={{ overflowY: 'auto' }}
              expanded={expanded}
              onNodeToggle={handleToggle}
            >
              {treeData.map((treeNode) =>
                RenderTreeComponente(
                  treeNode,
                  addNode,
                  deleteNode,
                  editNode,
                  setEditNodeId,
                  editNodeId,
                  editNodeName,
                  setEditNodeName,
                )
              )}
            </TreeView>
          </Grid>
        )
        }

      </Grid >

      <ScrollableDialogProps
        onCloseIcon={() => {
          setModalOpen(false)
        }}
        open={modalOpen}
        title="Agregar Cuenta"
        cancelTextBtn="Cerrar"
        confirmTextBtn="Guardar"
        onConfirm={handleSubmit(onSubmit)}
        minWidth="20%"
        contentNode={
          <Grid container spacing={3}>
            <CustomTextField
              control={form.control}
              name="codigo"
              defaultValue={form.getValues().codigo || ''}
              label={'Codigo'}
              error={form.formState.errors.codigo}
              helperText={form.formState.errors.codigo?.message} />

            <CustomTextField
              control={form.control}
              name="nombre"
              defaultValue={form.getValues().nombre || ''}
              label={texto.cuenta}
              error={form.formState.errors.nombre}
              helperText={form.formState.errors.nombre?.message} />

          </Grid>
        }
      />

    </>
  )

}